import React, { useEffect, useState, useMemo } from "react";
import { Download, Printer, Upload, Edit } from 'lucide-react';
import apiService from "../config";
import { useSignature } from '../DigitalSignature/UseSignatue';
import SignaturePad from '../DigitalSignature/SignaturePad';

const Parishtisht1Notice = ({ projectId = null }) => {
  const { uploadStatus, uploadError, selectedSignDocument, resetSignatureState, signDocument } = useSignature();
  const [data, setData] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(true);
  const [error, setError] = useState(null);
  const [locationInfo, setLocationInfo] = useState({});
  const [debugInfo, setDebugInfo] = useState(null);
  const [proposalNo, setProposalNo] = useState('');
  const [proposalData, setProposalData] = useState(null);
  const [regionalInchargeName, setRegionalInchargeName] = useState("");
  const [regionalInchargeDesignation, setRegionalInchargeDesignation] = useState("");
  const [InchargeName, setInchargeName] = useState("");
  const [InchargeDesignation, setInchargeDesignation] = useState("");
  const [signatureFile, setSignatureFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${today.getFullYear()}`;
  const userData = JSON.parse(localStorage.getItem('userData'));
  const userRole = parseInt(userData?.data?.user_role || userData?.user_role, 10);
  const userName = userData?.full_name || 'N/A';
  const userDesi = userData?.designation || 'N/A';

  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [pdfForSigning, setPdfForSigning] = useState(null);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [viewerFile, setViewerFile] = useState(null);

  const [isEditingAnusuchi1Header, setIsEditingAnusuchi1Header] = useState(false);
  const [isEditingAnusuchi2Header, setIsEditingAnusuchi2Header] = useState(false);

  const [anusuchi1Header, setAnusuchi1Header] = useState();
  const [anusuchi2Header, setAnusuchi2Header] = useState();

  const [header1Saving, setHeader1Saving] = useState(false);
  const [header2Saving, setHeader2Saving] = useState(false);

  const getProposalId = () => {
    const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
    return localStorage.getItem('currentProposalId') || findProposalId(selectedProject);
  };

  const findProposalId = (projectObj) => {
    if (!projectObj) return null;
    const possibleKeys = [
      'acquisition_proposal_no', 'land_acquisition_no', 'proposal_id', 'proposalId', 'proposal', 'id', 'project_id'
    ];
    for (const key of possibleKeys) {
      if (projectObj[key] !== undefined && projectObj[key] !== null && projectObj[key] !== '') {
        return projectObj[key];
      }
    }
    return null;
  };

  const fetchLandHoldings = async () => {
    setFetching(true);
    try {
      setLoading(true);
      setError(null);

      const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
      const projectIdFromStorage = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem('currentProposalId') || findProposalId(selectedProject);
      const currentProjectId = projectId || projectIdFromStorage;

      const storedProposal = JSON.parse(localStorage.getItem('selectedProposal') || '{}');

      console.log("Local selected proposal in pari-1", storedProposal);
      
     
      if (!currentProjectId || !proposalId) {
        const missingParams = [];
        if (!currentProjectId) missingParams.push('projectId');
        if (!proposalId) missingParams.push('proposalId');

        setError(`Missing required parameters: ${missingParams.join(', ')}. Please select a project first.`);
        setLoading(false);
        return;
      }

      const storedLocationInfo = localStorage.getItem('selectedLocationInfo');
      let apiParams = {
        proposalId: proposalId
      };

      if (storedLocationInfo) {
        const locationData = JSON.parse(storedLocationInfo);
        apiParams = { ...apiParams };
        setLocationInfo(locationData);
      }

      const result = await apiService.getLandHolding(currentProjectId, apiParams);

      setDebugInfo({
        apiResponse: result,
        requestParams: { projectId: currentProjectId, ...apiParams },
        responseStatus: result?.status,
        responseData: result?.data,
        dataType: typeof result?.data,
        dataLength: result?.data?.length,
        dataKeys: result?.data ? Object.keys(result.data) : null,
        rawResponse: result,
        isEmptyString: result === "",
        isNull: result === null,
        isUndefined: result === undefined
      });

      if (!result || result === "" || result === null || result === undefined) {
        setError(`API returned invalid response: ${JSON.stringify(result)}. Check API endpoint and network connection.`);
        return;
      }

      let dataArray = null;
      let responseStatus = result?.status || result?.statusCode || 200;

      if (responseStatus === 200 || responseStatus === "200") {
        if (result.proposalData && Array.isArray(result.proposalData) && result.proposalData.length > 0) {
          const proposalInfo = result.proposalData[0];
          console.log("Proposal Info", proposalInfo);
          
          setProposalNo(proposalInfo.acquisition_proposal_no);
          setProposalData(proposalInfo);
          setAnusuchi1Header(
            proposalInfo?.parishisht1_anusuchi1_header || proposalInfo?.acquisition_proposal_no ||
            "प्रकल्पाच्या आखणीमध्ये समाविष्ट जमिनींचा तपशील"
          );
          setAnusuchi2Header(
            proposalInfo?.parishisht1_anusuchi2_header || proposalInfo?.acquisition_proposal_no ||
            "प्रकल्पाच्या आखणीमध्ये समाविष्ट जमिनीचा गोषवारा"
          );
            if (proposalInfo?.acquisition_regional_incharge_name) {
        setRegionalInchargeName(proposalInfo.acquisition_regional_incharge_name);
      }
      if (proposalInfo?.acquisition_regional_incharge_designation) {
        setRegionalInchargeDesignation(proposalInfo.acquisition_regional_incharge_designation);
      }
      if (proposalInfo?.acquisition_incharge_designation) {
        setInchargeDesignation(proposalInfo.acquisition_incharge_designation);
      }
      if (proposalInfo?.acquisition_incharge_name) {
        setInchargeName(proposalInfo.acquisition_incharge_name);
      }

        }

        if (Array.isArray(result.data)) {
          dataArray = result.data;
        } else if (result.data && Array.isArray(result.data.data)) {
          dataArray = result.data.data;
        } else if (result.data && Array.isArray(result.data.items)) {
          dataArray = result.data.items;
        } else if (result.data && Array.isArray(result.data.records)) {
          dataArray = result.data.records;
        } else if (result.data && Array.isArray(result.data.landHoldings)) {
          dataArray = result.data.landHoldings;
        }

        if (dataArray && dataArray.length > 0) {
          const firstRecord = dataArray[0];
          if (!storedLocationInfo && firstRecord) {
            const extractedLocationInfo = {
              projectId: firstRecord.project_id || currentProjectId,
              district: firstRecord.dist_name,
              taluka: firstRecord.tehsil_name || firstRecord.taluka_name,
              village: firstRecord.village_name || firstRecord.VillageName,
              districtNo: firstRecord.dist_no,
              talukaNo: firstRecord.tehsil_no,
              villageNo: firstRecord.village_no
            };
            setLocationInfo(extractedLocationInfo);
            localStorage.setItem('selectedLocationInfo', JSON.stringify(extractedLocationInfo));
          }

          const transformedData = dataArray.map((item, index) => ({
            ...item,
            sr_no: index + 1
          }));

          setData(transformedData);
        } else {
          const errorMsg = result.data
            ? `API returned successful response but no data records found. Response structure: ${JSON.stringify(result.data, null, 2)}`
            : 'API returned empty response';
          setError(errorMsg);
        }
      } else {
        setError(`API returned status ${responseStatus}: ${result?.message || result?.error || 'Unknown error'}. Raw response: ${JSON.stringify(result)}`);
      }
    } catch (err) {
      console.error('❌ Error fetching land holdings:', err);
      setError(`Failed to fetch land holdings data: ${err.message}`);
      setDebugInfo({ error: err, errorMessage: err.message, errorStack: err.stack });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!previewUrl) {
      fetchLandHoldings();
    }
  }, [projectId]);

  useEffect(() => {
    if (selectedSignDocument) {
      const postSignedPdf = async () => {
        try {
          const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
          const projectId = selectedProject?.id || selectedProject?.project_id;
          const proposalId = localStorage.getItem("currentProposalId");

          if (!projectId || !proposalId) {
            console.error('Missing projectId or proposalId');
            return;
          }

          await apiService.postAddSignaturePDF(projectId, proposalId, "parishisht1", selectedSignDocument);

          const sectionRes = await apiService.getSectionFile(projectId, proposalId, "parishisht1");

          if (sectionRes?.isSignAvailable && sectionRes.data?.[0]?.file_path) {
            setPreviewUrl(sectionRes.data[0].file_path);
          }
        } catch (error) {
          console.error('Error posting signed PDF:', error);
        }
      };

      postSignedPdf();
    }
  }, [selectedSignDocument]);

  const handleAnusuchi1HeaderSave = async () => {
    try {
      const proposalId = getProposalId();
      if (!proposalId) {
        alert("Proposal ID not found");
        return;
      }
      setHeader1Saving(true);
      const formDataToSend = new FormData();
      formDataToSend.append("parishisht1_anusuchi1_header", anusuchi1Header || "");

      const response = await apiService.patch(`/patchUpdateProposal?proposalId=${proposalId}`, formDataToSend);
      if (response?.status === 200 || response?.status === 201) {
        alert("अनुसूची - 1 Header updated successfully!");
        setIsEditingAnusuchi1Header(false);
      } else {
        alert("Failed to update अनुसूची - 1 Header");
      }
    } catch (error) {
      console.error("Error updating अनुसूची - 1 header:", error);
      alert("Error while updating अनुसूची - 1 Header");
    } finally {
      setHeader1Saving(false);
    }
  };

  const handleAnusuchi2HeaderSave = async () => {
    try {
      const proposalId = getProposalId();
      if (!proposalId) {
        alert("Proposal ID not found");
        return;
      }
      setHeader2Saving(true);
      const formDataToSend = new FormData();
      formDataToSend.append("parishisht1_anusuchi2_header", anusuchi2Header || "");

      const response = await apiService.patch(`/patchUpdateProposal?proposalId=${proposalId}`, formDataToSend);
      if (response?.status === 200 || response?.status === 201) {
        alert("अनुसूची - 2 Header updated successfully!");
        setIsEditingAnusuchi2Header(false);
      } else {
        alert("Failed to update अनुसूची - 2 Header");
      }
    } catch (error) {
      console.error("Error updating अनुसूची - 2 header:", error);
      alert("Error while updating अनुसूची - 2 Header");
    } finally {
      setHeader2Saving(false);
    }
  };

  const handleViewSignedPdf = async () => {
    try {
      const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
      const projectId = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem("currentProposalId");

      if (!projectId || !proposalId) {
        alert("Project or Proposal not found");
        return;
      }

      const res = await apiService.getSectionFile(projectId, proposalId, "parishisht1");

      if (res?.isSignAvailable && res?.data?.[0]?.file_path) {
        setViewerFile(res.data[0].file_path); 
        setIsViewerOpen(true); 
      } else {
        alert("Digital signature PDF not available");
      }
    } catch (error) {
      console.error("Error opening signed PDF:", error);
      alert("Unable to open document");
    }
  };

  const handleUploadedFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setPdfForSigning(file);
    setShowSignaturePad(true);
  };

  const handlePrint = () => {
    if (previewUrl) {
      window.open(previewUrl, "_blank", "noopener,noreferrer");
      return;
    }

    if (!data || data.length === 0) {
      alert("No data to print yet.");
      return;
    }

    const wasEditing = editMode;
    setEditMode(false);

    setTimeout(() => {
      const printContent = document.getElementById("notice-content")?.innerHTML;

      if (!printContent || printContent.trim() === "") {
        alert("Print content is empty.");
        setEditMode(wasEditing);
        return;
      }
      const win = window.open("", "", "height=900,width=1200");
      win.document.write(`<html><head><title>परिशिष्ट-1</title>`);
      win.document.write(`<style>
        @page {
          size: A4 portrait;
          margin: 0.4in; 
        }
        body {
          font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
          line-height: 1.1;
          font-size: 13px;
        }
        .no-print {
          display: none !important;
        }
        table { 
          border-collapse: collapse; 
          width: 100%; 
          margin-top: 5px; 
          page-break-inside: auto;
        }
        tr {
          page-break-inside: avoid;
          page-break-after: auto;
        }
        thead {
          display: table-header-group;
        }
        th, td { 
          border: 1px solid black; 
          padding: 2px 4px !important; 
          text-align: center; 
          font-size: 11px;
        }
        h2, h3, p { text-align: center; margin: 2px 0; padding: 0; }
        .center-text { text-align: center; }
        .left-text { text-align: left; }
        
        .page-break { 
          page-break-before: always !important; 
          break-before: page !important; 
        }
        .keep-together {
          page-break-inside: avoid !important;
          break-inside: avoid !important;
        }
      </style></head><body>`);
      win.document.write(printContent);
      win.document.write("</body></html>");
      win.document.close();
      
      setTimeout(() => {
        win.print();
      }, 200);

      setEditMode(wasEditing);
    }, 200);
  };
   const groupedVillages = useMemo(() => {
    if (!data || data.length === 0) return [];
    const groups = {};
    data.forEach((item) => {
      const key = `${item.village_name}-${item.taluka_name}-${item.dist_name}`;
      if (!groups[key]) {
        groups[key] = {
          village_name: item.village_name,
          taluka_name: item.taluka_name,
          dist_name: item.dist_name,
          items: [],
        };
      }
      groups[key].items.push(item);
    });
    return Object.values(groups);
  }, [data]);

  const surveyTypes = ["सर्व्हे क्रमांक", "गट क्रमांक", "प्लॉट क्रमांक"];

  const calculateSecondPageData = (itemsToCalculate) => {
    let privateLandTotal = 0;
    const items = itemsToCalculate || data;
    items.forEach(item => {
      if (item.owners && item.owners.length > 0) {
        item.owners.forEach(owner => {
          if (owner.owner_aqr_area) {
            privateLandTotal += parseFloat(owner.owner_aqr_area) || 0;
          }
        });
      }
    });
    return privateLandTotal; 
  };

  const SignatureLoader = ({ text }) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg p-6 flex flex-col items-center space-y-4">
        <div className="animate-spin rounded-full h-10 w-10 border-4 border-blue-600 border-t-transparent"></div>
        <p className="text-sm font-medium text-gray-700">{text}</p>
      </div>
    </div>
  );

  return (
    <div className="max-w-6xl mx-auto p-6 bg-white">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center space-x-3">
          <button onClick={handlePrint} className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
            <Printer size={18} />
            <span>Print</span>
          </button>
         
        </div>
      </div>

      {previewUrl ? (
        <div className="w-full bg-white p-4 rounded-lg">
          <iframe
            src={`${previewUrl}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
            title="Anusuchi-1 PDF"
            width="100%"
            height="800px"
            style={{ border: "none", borderRadius: "8px", boxShadow: "none", outline: "none", margin: "0", padding: "0" }}
            frameBorder="0"
            seamless
          />
        </div>
      ) : (
        <>
          <div className="text-center mb-6">
            <div id="notice-content" style={{ margin: "10mm" }}>
              {loading ? (
                <div className="flex justify-center items-center h-96">
                  <p className="text-lg text-gray-600">Loading...</p>
                </div>
              ) : (
                <>
                  <h3 className="center-text font-semibold" style={{ margin: 0, padding: 0, lineHeight: "1.2" }}>परिशिष्ट - 1</h3>
                  <h3 className="center-text font-semibold" style={{ margin: 0, padding: 0, lineHeight: "1.2" }}>अनुसूची - 1</h3>
                  <h3 className="center-text font-semibold" style={{ margin: 0, padding: 0, lineHeight: "1.2" }}>प्रकल्पाच्या आखणीमध्ये समाविष्ट जमिनींचा तपशील</h3>
                  <h3 className="center-text" style={{ fontWeight: "bold", margin: "4px 0", padding: 0, lineHeight: "1.2" }}>
                    प्रकल्प नाव: {data.projectName || proposalData?.project_name} 
                  </h3>
                  
                  <div style={{ margin: 0, padding: 0 }}>
                    {isEditingAnusuchi1Header ? (
                      <div style={{ display: "flex", gap: "8px", justifyContent: "center", alignItems: "center", flexWrap: "wrap" }}>
                        <input
                          type="text"
                          value={anusuchi1Header}
                          onChange={(e) => setAnusuchi1Header(e.target.value)}
                          style={{ width: "60%", border: "1px solid #ccc", padding: "6px 8px", fontSize: "12px", borderRadius: "4px" }}
                        />
                        <button type="button" onClick={handleAnusuchi1HeaderSave} disabled={header1Saving} style={{ backgroundColor: "#4CAF50", color: "#fff", border: "none", borderRadius: "4px", padding: "6px 12px", cursor: "pointer", fontSize: "12px" }}>
                          {header1Saving ? "Saving..." : "Save"}
                        </button>
                        <button type="button" onClick={() => setIsEditingAnusuchi1Header(false)} style={{ backgroundColor: "#f44336", color: "#fff", border: "none", borderRadius: "4px", padding: "6px 12px", cursor: "pointer", fontSize: "12px" }}>
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexWrap: "wrap" }}>
                        <p className="center-text" style={{ fontWeight: "bold", margin: 0, padding: 0, lineHeight: "1.2" }}>
                          {anusuchi1Header || "प्रकल्पाच्या आखणीमध्ये समाविष्ट जमिनींचा तपशील"}
                        </p>
                        <button className="no-print" type="button" onClick={() => setIsEditingAnusuchi1Header(true)} style={{ backgroundColor: "#2196F3", color: "#fff", border: "none", borderRadius: "4px", padding: "4px 10px", cursor: "pointer", fontSize: "12px", marginLeft: "8px" }}>
                          <Edit className="h-4 w-4" />
                        </button>
                      </div>
                    )}
                  </div>

                  {groupedVillages.map((village, vIdx) => {
                    const surveyKramankData = village.items.filter(item => surveyTypes.includes(item.survey_type));
                    const gharKramankData = village.items.filter(item => item.survey_type === "घर क्रमांक.");

                    return (
                      <div key={`anusuchi1-village-${vIdx}`} style={{ marginTop: '20px' }}>
                        <p className="center-text" style={{ fontWeight: "bold", margin: "4px 0 8px 0", padding: 0, lineHeight: "1.2" }}>
                          मौजे : {village.village_name} , तालुका : {village.taluka_name} , जिल्हा : {village.dist_name}
                        </p>

                        {surveyKramankData.length > 0 && (
                          <table style={{ borderCollapse: "collapse", width: "100%", border: "1px solid black" }}>
                            <thead>
                              <tr>
                                <th style={{ border: "1px solid black", padding: "4px" }}>अ.क्र.</th>
                                <th style={{ border: "1px solid black", padding: "4px", minWidth: "170px" }}>भूधारकाचे नाव</th>
                                <th style={{ border: "1px solid black", padding: "4px" }}>गट/सर्व्हे </th>
                                <th style={{ border: "1px solid black", padding: "4px" }}>भूधारण पद्धती </th>
                                <th style={{ border: "1px solid black", padding: "4px", maxWidth: "120px" }}>7/12 प्रमाणे/अभिलेखाप्रमाणे एकुण क्षेत्र ({village.items[0]?.unit_name || ''})</th>
                                <th style={{ border: "1px solid black", padding: "4px" }}>हिस्सा क्षेत्र({village.items[0]?.unit_name || ''})</th>
                                <th style={{ border: "1px solid black", padding: "4px" }}>संपादनाचे प्रस्तावित क्षेत्र ({village.items[0]?.unit_name || ''})</th>
                              </tr>
                            </thead>
                            <tbody>
                              {[...surveyKramankData]
                                .sort((a, b) => a.LandAcquisition_id - b.LandAcquisition_id)
                                .map((item, idx) => {
                                  const hasOwners = item.owners && item.owners.length > 0;
                                  const rowSpanValue = hasOwners ? item.owners.length : 1;

                                  const ownersWithIndividualAqr = [];
                                  const ownersWithCommonArea = [];

                                  item.owners?.forEach(owner => {
                                    const hasIndividualAqr = owner.owner_aqr_area && parseFloat(owner.owner_aqr_area) > 0;
                                    if (hasIndividualAqr) {
                                      ownersWithIndividualAqr.push(owner);
                                    } else if (owner.common_area && parseFloat(owner.common_area) > 0) {
                                      ownersWithCommonArea.push(owner);
                                    }
                                  });

                                  return hasOwners ? (
                                    <React.Fragment key={idx}>
                                      {item.owners.map((owner, ownerIdx) => {
                                        const hasIndividualAqr = owner.owner_aqr_area && parseFloat(owner.owner_aqr_area) > 0;
                                        const hasCommonArea = owner.common_area && parseFloat(owner.common_area) > 0;
                                        const isFirstCommonAreaOwner = hasCommonArea &&
                                          ownerIdx === item.owners.findIndex(o =>
                                            o.common_area && parseFloat(o.common_area) > 0 &&
                                            (!o.owner_aqr_area || parseFloat(o.owner_aqr_area) === 0)
                                          );

                                        return (
                                          <tr key={`${idx}-owner-${ownerIdx}`}>
                                            {ownerIdx === 0 && (
                                              <td rowSpan={rowSpanValue} style={{ border: "1px solid black", padding: "4px", textAlign: "center", verticalAlign: "middle" }}>
                                                {idx + 1}
                                              </td>
                                            )}
                                            <td style={{ border: "1px solid black", padding: "4px", textAlign: "left", whiteSpace: "pre-line" }}>
                                              {owner.owner_name?.split(",").map((name, i, arr) => i < arr.length - 1 ? name.trim() + "," : name.trim()).join("\n")}
                                            </td>
                                            {ownerIdx === 0 && (
                                              <td rowSpan={rowSpanValue} style={{ border: "1px solid black", padding: "4px", verticalAlign: "middle", textAlign: "center" }}>
                                                {item.survey_no}
                                              </td>
                                            )}
                                            {ownerIdx === 0 && (
                                              <td rowSpan={rowSpanValue} style={{ border: "1px solid black", padding: "4px", verticalAlign: "middle", textAlign: "center" }}>
                                                {item.land_holding_type || "-"}
                                              </td>
                                            )}
                                            {ownerIdx === 0 && (
                                              <td rowSpan={rowSpanValue} style={{ border: "1px solid black", padding: "4px", verticalAlign: "middle", textAlign: "center" }}>
                                                {parseFloat(item.total_7_12_area || 0).toFixed(2)}
                                              </td>
                                            )}
                                            <td style={{ border: "1px solid black", padding: "4px", textAlign: "center", verticalAlign: "middle" }}>
                                              {parseFloat(owner.owner_total_area || 0).toFixed(2)}
                                            </td>
                                            {hasIndividualAqr ? (
                                              <td style={{ border: "1px solid black", padding: "4px", textAlign: "center", verticalAlign: "middle" }}>
                                                {parseFloat(owner.owner_aqr_area).toFixed(2)}
                                              </td>
                                            ) : hasCommonArea && isFirstCommonAreaOwner ? (
                                              <td rowSpan={ownersWithCommonArea.length} style={{ border: "1px solid black", padding: "4px", textAlign: "center", verticalAlign: "middle" }}>
                                                {parseFloat(owner.common_area).toFixed(2)}
                                              </td>
                                            ) : hasCommonArea && !isFirstCommonAreaOwner ? (
                                              null
                                            ) : (
                                              <td style={{ border: "1px solid black", padding: "4px", textAlign: "center", verticalAlign: "middle" }}>
                                                0.00
                                              </td>
                                            )}
                                          </tr>
                                        );
                                      })}
                                    </React.Fragment>
                                  ) : null;
                                })}
                              <tr>
                                <td colSpan={5} style={{ border: "1px solid black", padding: "4px", fontWeight: "bold", textAlign: "right" }}>एकुण</td>
                                <td style={{ border: "1px solid black", padding: "4px", fontWeight: "bold", textAlign: "center" }}>
                                  {surveyKramankData.reduce((sum, item) => sum + (item.owners?.reduce((ownerSum, o) => ownerSum + Number(o.owner_total_area || 0), 0) || 0), 0).toFixed(2)}
                                </td>
                                <td style={{ border: "1px solid black", padding: "4px", fontWeight: "bold", textAlign: "center" }}>
                                  {(Math.round(surveyKramankData.reduce((sum, item) => sum + (item.owners?.reduce((ownerSum, o) => ownerSum + Number(o.owner_aqr_area || 0), 0) || 0), 0) * 100) / 100).toFixed(2)}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        )}

                        {gharKramankData.length > 0 && (
                          <table className="mt-8" style={{ borderCollapse: "collapse", width: "100%", border: "1px solid black" }}>
                            <thead>
                              <tr>
                                <th style={{ border: "1px solid black", padding: "4px" }}>अ.क्र.</th>
                                <th style={{ border: "1px solid black", padding: "4px", minWidth: "170px" }}>घर मालकाचे नाव</th>
                                <th style={{ border: "1px solid black", padding: "4px" }}>घर क्रमांक </th>
                                <th style={{ border: "1px solid black", padding: "4px" }}>भूधारण पद्धती </th>
                                <th style={{ border: "1px solid black", padding: "4px", maxWidth: "120px" }}>7/12 प्रमाणे/अभिलेखाप्रमाणे एकुण क्षेत्र (चौरस फूट)</th>
                                <th style={{ border: "1px solid black", padding: "4px" }}>हिस्सा क्षेत्र (चौरस फूट)</th>
                                <th style={{ border: "1px solid black", padding: "4px" }}>संपादनाचे प्रस्तावित क्षेत्र (चौरस फूट)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {[...gharKramankData]
                                .sort((a, b) => a.LandAcquisition_id - b.LandAcquisition_id)
                                .map((item, idx) => {
                                  const hasOwners = item.owners && item.owners.length > 0;
                                  const rowSpanValue = hasOwners ? item.owners.length : 1;

                                  return hasOwners ? (
                                    <React.Fragment key={idx}>
                                      {item.owners.map((owner, ownerIdx) => (
                                        <tr key={`${idx}-owner-${ownerIdx}`}>
                                          {ownerIdx === 0 && (
                                            <td rowSpan={rowSpanValue} style={{ border: "1px solid black", padding: "4px", textAlign: "center" }}>{idx + 1}</td>
                                          )}
                                          <td style={{ border: "1px solid black", padding: "4px", textAlign: "left", whiteSpace: "pre-line" }}>
                                            {owner.owner_name?.split(",").map((name, i, arr) => i < arr.length - 1 ? name.trim() + "," : name.trim()).join("\n")}
                                          </td>
                                          {ownerIdx === 0 && (
                                            <td rowSpan={rowSpanValue} style={{ border: "1px solid black", padding: "4px", verticalAlign: "middle", textAlign: "center" }}>{item.survey_no}</td>
                                          )}
                                          {ownerIdx === 0 && (
                                            <td rowSpan={rowSpanValue} style={{ border: "1px solid black", padding: "4px", verticalAlign: "middle", textAlign: "center" }}>{item.land_holding_type || "-"}</td>
                                          )}
                                          {ownerIdx === 0 && (
                                            <td rowSpan={rowSpanValue} style={{ border: "1px solid black", padding: "4px", verticalAlign: "middle", textAlign: "center" }}>{parseFloat(item.total_area || 0).toFixed(2)}</td>
                                          )}
                                          <td style={{ border: "1px solid black", padding: "4px", textAlign: "center", verticalAlign: "middle" }}>{parseFloat(owner.owner_total_area || 0).toFixed(2)}</td>
                                          <td style={{ border: "1px solid black", padding: "4px", textAlign: "center", verticalAlign: "middle" }}>{parseFloat(owner.owner_aqr_area || 0).toFixed(2)}</td>
                                        </tr>
                                      ))}
                                    </React.Fragment>
                                  ) : null;
                                })}
                              <tr>
                                <td colSpan={5} style={{ border: "1px solid black", padding: "4px", fontWeight: "bold", textAlign: "right" }}>एकुण</td>
                                <td style={{ border: "1px solid black", padding: "4px", fontWeight: "bold", textAlign: "center" }}>
                                  {gharKramankData.reduce((sum, item) => sum + (item.owners?.reduce((ownerSum, o) => ownerSum + Number(o.owner_total_area || 0), 0) || 0), 0).toFixed(2)}
                                </td>
                                <td style={{ border: "1px solid black", padding: "4px", fontWeight: "bold", textAlign: "center" }}>
                                  {(Math.round(gharKramankData.reduce((sum, item) => sum + (item.owners?.reduce((ownerSum, o) => ownerSum + Number(o.owner_aqr_area || 0), 0) || 0), 0) * 100) / 100).toFixed(2)}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        )}
                      </div>
                    );
                  })}

                  <p style={{ textAlign: "center", marginTop: "20px", fontSize: "small" }}></p>

                  <div className="keep-together" style={{ pageBreakInside: "avoid", breakInside: "avoid", marginTop: "20px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                      <div style={{ textAlign: "left" }}>
                        <p>दिनांक: {formattedDate}</p>
                        <p>ठिकाण: {proposalData?.acquisition_incharge_address}</p>
                      </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                      <div style={{ textAlign: "center", marginTop: "60px", lineHeight: "1.5" }}>
                        <p> {regionalInchargeName ? ` (${regionalInchargeName})` : ""}</p>
                        <p> {regionalInchargeDesignation ? ` ${regionalInchargeDesignation}` : ""}</p>
                      </div>
                      <div style={{ textAlign: "center", lineHeight: "1.5", marginTop: "60px" }}>
                        <p> {InchargeName ? ` (${InchargeName})` : ""}</p>
                        <p> {InchargeDesignation ? ` ${InchargeDesignation}` : ""}</p>
                      </div>
                    </div>
                  </div>

                  {/* 🔹 HIDDEN IN PRINT to prevent margin collapse splitting */}
                  <hr className="my-6 border-t-2 border-gray-400 no-print" />

                  {/* 🔹 DEDICATED INVISIBLE PAGE BREAK ELEMENT */}
                  <div className="page-break" style={{ pageBreakBefore: "always", breakBefore: "page", marginTop: "20px" }}></div>

                  <div className="anushuchi-two" style={{ width: "100%", display: "block" }}>
                    
                    {/* 🔹 KEEP HEADERS TOGETHER SO THEY NEVER SPLIT ACROSS PAGES */}
                    <div className="keep-together" style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
                      <h3 className="center-text font-semibold" style={{ margin: 0, padding: 0, lineHeight: "1.2" }}>परिशिष्ट - 1</h3>
                      <h3 className="center-text font-semibold" style={{ margin: 0, padding: 0, lineHeight: "1.2" }}>अनुसूची - 2</h3>
                      <h3 className="center-text font-semibold" style={{ margin: 0, padding: 0, lineHeight: "1.2" }}>प्रकल्पाच्या आखणीमध्ये समाविष्ट जमिनीचा गोषवारा</h3>
                      <h3 className="center-text" style={{ fontWeight: "bold", margin: "4px 0", padding: 0, lineHeight: "1.2" }}>
                        प्रकल्प नाव: {data.projectName || proposalData?.project_name} 
                      </h3>
                      <div style={{ margin: 0, padding: 0 }}>
                        {isEditingAnusuchi2Header ? (
                           <div style={{ display: "flex", gap: "8px", justifyContent: "center", alignItems: "center", flexWrap: "wrap" }}>
                             <input type="text" value={anusuchi2Header} onChange={(e) => setAnusuchi2Header(e.target.value)} style={{ width: "60%", border: "1px solid #ccc", padding: "6px 8px", fontSize: "12px", borderRadius: "4px" }} />
                             <button type="button" onClick={handleAnusuchi2HeaderSave} disabled={header2Saving} style={{ backgroundColor: "#4CAF50", color: "#fff", border: "none", borderRadius: "4px", padding: "6px 12px", cursor: "pointer", fontSize: "12px" }}>
                               {header2Saving ? "Saving..." : "Save"}
                             </button>
                             <button type="button" onClick={() => setIsEditingAnusuchi2Header(false)} style={{ backgroundColor: "#f44336", color: "#fff", border: "none", borderRadius: "4px", padding: "6px 12px", cursor: "pointer", fontSize: "12px" }}>
                               Cancel
                             </button>
                           </div>
                        ) : (
                          <div style={{ display: "flex", gap: "8px", justifyContent: "center", alignItems: "center", flexWrap: "wrap" }}>
                            <p className="center-text" style={{ fontWeight: "bold", margin: 0, padding: 0, lineHeight: "1.2" }}>
                              {anusuchi2Header || "प्रकल्पाच्या आखणीमध्ये समाविष्ट जमिनीचा गोषवारा"}
                            </p>
                            <button className="no-print" type="button" onClick={() => setIsEditingAnusuchi2Header(true)} style={{ backgroundColor: "#2196F3", color: "#fff", border: "none", borderRadius: "4px", padding: "4px 10px", cursor: "pointer", fontSize: "12px" }}>
                              <Edit className="h-4 w-4" />
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  
                    {groupedVillages.map((village, vIdx) => {
                      const villageTotal = calculateSecondPageData(village.items);
                      
                      return (
                        <div key={`anusuchi2-village-${vIdx}`} style={{ marginTop: '20px' }}>
                          <p className="center-text" style={{ fontWeight: "bold", margin: "4px 0 8px 0", padding: 0, lineHeight: "1.2" }}>
                            मौजे : {village.village_name} , तालुका : {village.taluka_name} , जिल्हा : {village.dist_name}
                          </p>
                          <table style={{ borderCollapse: "collapse", width: "100%", border: "1px solid black" }}>
                            <thead>
                              <tr>
                                <th style={{ border: "1px solid black", padding: "4px" }}>अ.क्र.</th>
                                <th style={{ border: "1px solid black", padding: "4px" }}>जमिनीचा प्रकार</th>
                                <th style={{ border: "1px solid black", padding: "4px" }}>भूसंपादन करावयाचे एकूण क्षेत्र ({village.items[0]?.unit_name || ''})</th>
                              </tr>
                            </thead>
                            <tbody>
                              {[
                                { type: "खाजगी जमीन", area: Number(villageTotal || 0) },
                                { type: "सरकारी जमीन", area: 0.0 },
                                { type: "केंद्र/राज्य शासनाच्या अखत्यारीतील सार्वजनिक उपक्रमाकडील जमीन", area: 0.0 },
                                { type: "केंद्र/राज्य शासनाच्या विभागाकडील जमीन", area: 0.0 },
                                { type: "वन जमीन", area: 0.0 },
                                { type: "स्थानिक स्वराज्य संस्थाकडील जमीन", area: 0.0 },
                                { type: "अन्य जमीन", area: 0.0 },
                              ].map((row, i) => (
                                <tr key={i}>
                                  <td style={{ border: "1px solid black", padding: "4px", textAlign: "center" }}>{i + 1}</td>
                                  <td style={{ border: "1px solid black", padding: "4px", textAlign: "left" }}>{row.type}</td>
                                  <td style={{ border: "1px solid black", padding: "4px", textAlign: "center" }}>
                                    {Number(row.area || 0).toFixed(2)}
                                  </td>
                                </tr>
                              ))}
                              <tr>
                                <td colSpan={2} style={{ border: "1px solid black", padding: "4px", fontWeight: "bold", textAlign: "right" }}>एकूण :</td>
                                <td style={{ border: "1px solid black", padding: "4px", fontWeight: "bold", textAlign: "center" }}>{villageTotal.toFixed(2)}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      )
                    })}

                    <p style={{ textAlign: "center", marginTop: "20px", fontSize: "small" }}></p>
                    
                    <div className="keep-together" style={{ pageBreakInside: "avoid", breakInside: "avoid", marginTop: "20px" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                        <div style={{ textAlign: "left" }}>
                          <p>दिनांक: {formattedDate}</p>
                          <p>ठिकाण: {proposalData?.acquisition_incharge_address}</p>
                        </div>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                        <div style={{ textAlign: "center", marginTop: "60px", lineHeight: "1.5" }}>
                          <p> {regionalInchargeName ? ` (${regionalInchargeName})` : ""}</p>
                          <p> {regionalInchargeDesignation ? ` ${regionalInchargeDesignation}` : ""}</p>
                        </div>
                        <div style={{ textAlign: "center", lineHeight: "1.5", marginTop: "60px" }}>
                          <p> {InchargeName ? ` (${InchargeName})` : ""}</p>
                          <p> {InchargeDesignation ? ` ${InchargeDesignation}` : ""}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}

      {showSignaturePad && pdfForSigning && (
        <SignaturePad
          pdfFile={pdfForSigning}
          onSign={(signaturesArray) => {
            setShowSignaturePad(false);
            signDocument(pdfForSigning, signaturesArray).then(() => {
              setPdfForSigning(null);
            });
          }}
          onCancel={() => {
            setShowSignaturePad(false);
            setPdfForSigning(null);
          }}
        />
      )}

      {isViewerOpen && viewerFile && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
          <div className="bg-white rounded-lg w-[80%] max-w-6xl h-[80%] relative">
            <div className="flex justify-between items-center px-4 py-2 border-b">
              <h3 className="text-lg font-semibold">Document Viewer</h3>
              <button onClick={() => setIsViewerOpen(false)} className="text-xl font-bold">✕</button>
            </div>
            <iframe src={viewerFile} title="Parishisht-1 Signed PDF" className="w-full h-full" />
          </div>
        </div>
      )}

      {(uploadStatus === "signing" || uploadStatus === "uploading") && (
        <SignatureLoader text={uploadStatus === "signing" ? "Applying digital signature…" : "Uploading signed document…"} />
      )}
    </div>
  );
};

export default Parishtisht1Notice;